"use client";

import { useConsent } from "@shared/components/ConsentProvider";

export { useConsent };

/** @deprecated Prefer `useConsent` for granular categories. */
export function useCookieConsent() {
	const c = useConsent();
	return {
		userHasConsented: c.status === "decided" && c.hasConsent("analytics"),
		allowCookies: c.acceptAll,
		declineCookies: c.rejectNonEssential,
	};
}
